import React, { Component } from 'react'

export class Footer extends Component {
    render() {
        return (
            <div>
                <footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">

          {/* <div class="col-lg-6 col-md-6 footer-info">
            <h3>ClipTax</h3>
           
            <p  style={{ fontSize: 16, fontWeight: 500, color: "#FFF" }}>Cliptax helps organization and individuals create value they are looking for. Cliptax is an independent and integrated organization committed to delivering quality in all sorts of Taxation and compliance and consultancy services. Our experienced and elite professionals provide you with exceptional, complete financial and legal solutions on matters related to Income tax, financial services, company law matters, foreign collaborations, import-export consultancy, GST and transfer pricing.</p>
          </div> */}
 <div class="col-lg-3 col-md-6 footer-links">
            <h4>Income Tax</h4>
            <ul>
              <li><a href="#">Self E-Filing</a></li>
              <li><a href="#">Expert Assisted E-Filing</a></li>
              <li><a href="#">Premium Assisted E-Filing</a></li>
              <li><a href="#">Foreign Incometax Filing</a></li>
              <li><a href="#">Tax Consultancy Services</a></li>
              <li><a href="#">Accounting</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-links">
            <h4>GST</h4>
            <ul>
              <li><a href="#">GST Registration</a></li>
              <li><a href="#">GST Return Filing</a></li>
              <li><a href="#">GST Advisory</a></li>
              <li><a href="#">GST Audit</a></li>
              <li><a href="#">GST Assistment</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-links">
            <h4>Loan</h4>
            <ul>
              <li><a href="#">Personal Loan</a></li>
              <li><a href="#">Home Loan</a></li>
              <li><a href="#">Car Loan</a></li>
              <li><a href="#">Two-Wheeler Loan</a></li>
              <li><a href="#">Education Loan</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-contact">
            <h4>Contact Us</h4>
            <p style={{ fontSize: 14, fontWeight: 500, color: "#004767" }}>
            <strong>Address:</strong> 1407, Parinee Crescenzo, B-Wing, G Block, BKC, Bandra(East), Mumbai-400051 <br/>
              <strong>Contact:</strong> +91-9930514109 / +91-9136976406<br/>
              <strong>Email:</strong> contactus@cliptax.com<br/>
            </p>

            <div class="social-links">
              <a href="#" class="twitter" style={{backgroundColor:"#004767"}}><i class="fa fa-twitter" ></i></a>
              <a href="#" class="facebook" style={{backgroundColor:"#004767"}}><i class="fa fa-facebook"></i></a>
              <a href="#" class="instagram" style={{backgroundColor:"#004767"}}><i class="fa fa-instagram"></i></a>
              <a href="#" class="google-plus" style={{backgroundColor:"#004767"}}><i class="fa fa-google-plus"></i></a>
              <a href="#" class="linkedin" style={{backgroundColor:"#004767"}}><i class="fa fa-linkedin"></i></a>
            </div>

          </div>

          {/* <div class="col-lg-3 col-md-6 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Cliptax helps organization and individuals create value they are looking for. Cliptax is an independent and integrated organization committed to delivering quality.</p>
            <form action="" method="post">
              <input type="email" name="email"></input><input type="submit" value="Subscribe"></input>
            </form>
          </div> */}

        </div>
        <div class="row">
        <div class="col-lg-12 col-md-6 footer-info">
            {/* <h3>ClipTax</h3> */}
            <a href="/">
                <img src="assets/img/logo.png" alt="" class="img-fluid" style={{width:120, height:55}}></img>
              </a>
            <p  style={{ fontSize: 16, fontWeight: 500, color: "#004767", paddingTop:5 }}>Cliptax helps organization and individuals create value they are looking for. Cliptax is an independent and integrated organization committed to delivering quality in all sorts of Taxation and compliance and consultancy services. Our experienced and elite professionals provide you with exceptional, complete financial and legal solutions on matters related to Income tax, financial services, company law matters, foreign collaborations, import-export consultancy, GST and transfer pricing.</p>
            <br/>
            <p>Copyrights © 2020 Cliptax. All Rights Reserved.</p>
          </div> 
          </div>
      </div>
     
    </div>
  
   
  </footer>

  <a href="#" class="back-to-top"><i class="fa fa-chevron-up"></i></a>
            </div>
        )
    }
}

export default Footer
